import { render } from "./TicketCrear.vue?vue&type=template&id=25187676"
import script from "./TicketCrear.vue?vue&type=script&lang=js"
export * from "./TicketCrear.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__